/**
 * Retrieve the headers of the resource in the layer.
 * Resolve promise with true if found else resolve with false if resource not found.
 *
 * Usage:
 *
 *  import ResourceCheck from 'data/ResourceCheck'
 *  const resourceFound = await ResourceCheck(url) // RESOURCE_FOUND | RESOURCE_NOT_FOUND
 *
 */

import isString from 'lodash/isString'
import trim from 'lodash/trim'

import PoziAPIData from 'api/data'

const RESOURCE_FOUND = true
const RESOURCE_NOT_FOUND = false

export default function (url, timeout = 10000, bRejectOnError = false) {
  // console.debug('ResourceCheck', url, timeout, bRejectOnError)

  return new Promise(function (resolve, reject) {
    if (!isString(url)) {
      console.log('Resource url is not a string.')
      return resolve(RESOURCE_NOT_FOUND)
    }
    if (trim(url) === '') {
      console.log('Resource url is empty.')
      return resolve(RESOURCE_NOT_FOUND)
    }

    const error = function (jqxhr, textStatus, err) {
      console.log('ResourceCheck - error', textStatus, err, jqxhr)
      console.log('Resource headers not detected for url', url)

      return bRejectOnError
        ? reject(jqxhr)
        : resolve(RESOURCE_NOT_FOUND)
    }

    const success = function (response, textStatus, jqxhr) {
      const responseContentType = jqxhr.getResponseHeader('content-type')

      // console.debug('ResourceCheck - success response', responseContentType, textStatus, response)

      // Detect seemingly successful responses that are actually error pages. This can
      // happen with MS Azure App Proxy for example where a login attempt gets aborted.
      // We therefore enforce that the content type is 'application/json'
      const isJson = responseContentType.includes('application/json')
      if (!isJson) {
        console.log('ResourceCheck - success - but not JSON, therefore not a valid response.', responseContentType, url)
        return resolve(RESOURCE_NOT_FOUND)
      }

      console.debug('Resource headers detected for url', url)
      return resolve(RESOURCE_FOUND)
    }

    const ajaxOptions = {
      cache: false,
      dataType: 'text',
      error: () => {}, // use dummy function to avoid ajaxFailDefault being called
      success,
      timeout,
      url
    }

    PoziAPIData().ajax(ajaxOptions)
      .catch(error) // We need this, otherwise we can get 'uncaught in promise' error
  })
}
